import React, { useState } from 'react';
import './nav-menu.scss';
import { DropdownToggle, DropdownMenu, UncontrolledDropdown } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import useFilteredRoutes from 'components/use-filtered-routes/use-filtered-routes';

interface SubRoute {
  name: string;
  path: string;
  text: string;
}

interface Route {
  name: string;
  path: string;
  text: string;
  component?: React.ComponentType;
  subMenuItems?: SubRoute[];
}

interface NavMenuProps {
  routes: Route[];
}

const NavMenu = ({ routes }: NavMenuProps) => {
  const filteredRoutes = useFilteredRoutes(routes) as Route[];

  const [dropdownOpen, setDropdownOpen] = useState<Record<string, boolean>>({
    Cards: false,
    Reports: false,
    Maintenance: false,
  });

  const onMouseHover = (route: string, isHovering: boolean) => {
    setDropdownOpen((prevDropdownOpen) => ({
      ...prevDropdownOpen,
      [route]: isHovering,
    }));
  };

  return (
    <div className='menu'>
      <ul className='menu__list'>
        {filteredRoutes.length > 1 &&
          filteredRoutes.map((route) => {
            if (route.subMenuItems) {
              return (
                <li key={route.name}>
                  <UncontrolledDropdown
                    className={'menu__dropdown'}
                    onMouseOver={() => onMouseHover(route.text, true)}
                    onMouseLeave={() => onMouseHover(route.text, false)}
                    isOpen={dropdownOpen[route.text]}
                  >
                    <DropdownToggle className='menu__dropdown-toggle' variant='success'>
                      <NavLink
                        to={route.path}
                        className={`menu__item ${!route.component && 'menu__item--unclickable'}`}
                        {...({
                          isActive: (match: any, location: any) => {
                            if (!location) return false;
                            return (
                              location.pathname === route.path ||
                              route.subMenuItems!.some((e: SubRoute) => e.path === location.pathname)
                            );
                          },
                        } as any)}
                      >
                        {route.text}
                      </NavLink>
                    </DropdownToggle>
                    <DropdownMenu className='menu__dropdown-menu'>
                      {route.subMenuItems.map((subRoute) => {
                        return (
                          <div key={subRoute.name}>
                            <NavLink to={subRoute.path} className='menu__dropdown-item'>
                              {' '}
                              {subRoute.text}{' '}
                            </NavLink>
                          </div>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              );
            }
            if (!route.subMenuItems) {
              return (
                <li key={route.name}>
                  <NavLink to={route.path} {...({ exact: true } as any)} className={'menu__item'}>
                    {route.text}
                  </NavLink>
                </li>
              );
            }
          })}
      </ul>
    </div>
  );
};

export default NavMenu;
